import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const LifeInsuranceGrowthRate = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="LifeInsuranceGrowthRate"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          label="Growth rate"
          tooltip="The rate the market value for the policy grows."
          decimalScale={2}
          rightIcon="far fa-percent"
          onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
          allowNegative={false}
          maxLength={6}
        />
      )}
    />
  );
};
